import {
  getCurrentQuizType,
  getIsQuestionMarked,
  getQuizQuestionAnswers,
  getCurrentQuestionInfo
} from '@selectors/quizTaking';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';

const useQuestionStatus = (sectionUID, questionUID) => {
  const { isSubjective } = useSelectorWithShallowEqual(getCurrentQuizType);
  const answers = useSelectorWithShallowEqual(
    getQuizQuestionAnswers(sectionUID, questionUID)
  );
  const isMarked = useSelectorWithShallowEqual(
    getIsQuestionMarked(sectionUID, questionUID)
  );
  const { sectionUID: selectedSectionUID, questionUID: selectedQuestionUID } =
    useSelectorWithShallowEqual(getCurrentQuestionInfo);

  return {
    isSelected:
      sectionUID === selectedSectionUID && questionUID === selectedQuestionUID,
    isAttempted: isSubjective ? answers[0] === '1' : answers.length,
    isMarked
  };
};

export default useQuestionStatus;
